// Cluster-specific status badges (mirrors zoneDisplay.tsx — clusters = the flat
// sibling of zones, ADR-052). The accountability label builders + chain mappers
// (chainLabels / coverageLabels / coverageOf / toAssignmentItems / …) are shared
// across every scope entity — see components/patterns/accountabilityDisplay.ts.

import type { TFunction } from 'i18next';
import { Badge } from '../../../components/ui/Badge.js';

// ── status / default badges ───────────────────────────────────────────────────
export function ClusterStatusBadge({ disabled, t }: { disabled: boolean; t: TFunction }) {
  return (
    <Badge variant={disabled ? 'neutral' : 'success'} appearance="subtle">
      {disabled ? t('status.disabled') : t('status.active')}
    </Badge>
  );
}

// Status pill + a Default chip only when the cluster is the default (the header /
// peek / list-name group).
export function ClusterStatusGroup({
  isDisabled,
  isDefault,
  t,
}: {
  isDisabled: boolean;
  isDefault: boolean;
  t: TFunction;
}) {
  return (
    <span className="inline-flex items-center gap-2">
      <ClusterStatusBadge disabled={isDisabled} t={t} />
      {isDefault && (
        <Badge variant="brand" appearance="subtle">
          {t('default')}
        </Badge>
      )}
    </span>
  );
}
